"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
;
var Content = /** @class */ (function () {
    function Content(data) {
        this.page = {
            alias: data.page.alias,
            navId: data.page.nav_id,
            description: data.page.description,
            id: data.page.id,
            keywords: data.page.keywords,
            langId: data.page.lang_id,
            title: data.page.title,
            titleTag: data.page.title_tag
        };
        this.layout = {
            id: data.layout.id,
            name: data.layout.name
        };
        this.properties = {
            announce: data.properties.announce,
            date: data.properties.date
        };
        this.placeholders = data.placeholders;
    }
    return Content;
}());
exports.Content = Content;
//# sourceMappingURL=Content.js.map